import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { PlatformService } from "services/platform.service";

@Component({
	selector: 'ras-carousel',
	templateUrl: './carousel.component.html',
	styleUrls: ['./carousel.component.sass']
})
export class CarouselComponent implements OnInit, OnDestroy {

	@Output() action = new EventEmitter()

	@Input() interval: number = 5000

	@Input() img: string
	@Input() actionText: string
	_numFrames: number = 0
	@Input()
	set numFrames(value: number) {
		this._numFrames = value
		this.frames = []
		for (let i = 0; i < value; i += 1) {
			this.frames.push({
				src: this.img.replace('%d', (i + 1).toString().padStart(2, '0'))
			})
		}
	}

	public current_frame = 0

	public frames: any[]

	private timer = null

	constructor(private platform: PlatformService) { }

	change(frame) {
		if (frame < 0) this.current_frame = this.frames.length - 1
		else if (frame >= this.frames.length) this.current_frame = 0
		else this.current_frame = frame

		if (this.timer) clearTimeout(this.timer)
		this.timer = setTimeout( () => this.change(this.current_frame + 1), this.interval)
	}

	ngOnDestroy() {
		if (this.timer) clearTimeout(this.timer)
	}

	ngOnInit() {
		if (this.platform.isBrowser) {
			this.timer = setTimeout(() => this.change(this.current_frame + 1), this.interval)
		}
	}

}
